import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { BranchProvider } from './context/BranchContext';
import { demoPosPath } from './demoPosPaths';
import Shell from './components/layout/Shell';
import Home from './pages/Home';
import Bills from './pages/Bills';
import BillWizard from './pages/BillWizard';
import Analytics from './pages/Analytics';
import './theme.css';

/** Routes are relative, so the same tree works at `/` (standalone) and `/naturals/demo-pos/*` (main app). */
export function DemoPosRoutes() {
  return (
    <BranchProvider>
      <Routes>
        <Route element={<Shell />}>
          <Route index element={<Home />} />
          <Route path="bills" element={<Bills />} />
          <Route path="bills/:billId" element={<BillWizard />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="*" element={<Navigate to={demoPosPath()} replace />} />
        </Route>
      </Routes>
    </BranchProvider>
  );
}

/** Standalone `npm run start:demo-pos` wraps routes in BrowserRouter; main App.js already has a router. */
export default function DemoPosApp() {
  if (process.env.REACT_APP_TARGET === 'demo-pos') {
    return (
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <DemoPosRoutes />
      </BrowserRouter>
    );
  }
  return <DemoPosRoutes />;
}
